import { Tooltip } from "@mui/material";
import _ from "lodash";
import { memo, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import HTMLInput from "../../_Components/HTMLInput";
import SelectComponent from "../../_Components/ReactSelectComponent";
import SplitNumber from "../../_Components/SplitNumber";
import AddCircleRounded from "@mui/icons-material/AddCircleOutlineRounded";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // استایل پیش‌فرض
import SwitchBox from "../../_Components/SwitchBox";

const switchItems1 = [{ title: "خیر", color: "#808080", value: false }, { title: "بله", color: "#06b463", value: true }]


const ReserveItemGroup = ({
  nameDate,
  group,
  service,
  reserveDescriptions,
  reserveDetailGroup,
  openModalAddDescription,
  reserveItems,
  reserveDetailJson,
  isDefaultSetter,
  formatTime
}) => {
  const { watch, control } = useFormContext()
  useEffect(() => {
    isDefaultSetter(reserveDetailJson, nameDate)
  }, [reserveDetailJson, service, nameDate])
  return (
    <div className="bg-white rounded-3 p-2 my-3" style={{ border: "1px solid #ddd " }}>
      <div className=" pb-2" style={{ borderBottom: "1px solid #ddd " }}>
        <Row className="justify-content-md-right position-relative">
          <Col sx="12" sm="7" className="my-auto">
            <Controller
              control={control}
              key={JSON.stringify(reserveDetailGroup ?? {}) + service?.toString() + `${nameDate}-${group.id}-ID` + JSON.stringify(reserveDetailJson)}
              name={`${nameDate}-${service}-${group.id}-ID`}
              render={({ field }) => <input
                type="checkbox"
                style={{ margin: "0 5px" }}
                title="نمایش/عدم نمایش"
                checked={field.value ?? false}
                {...field}
              />}
            />

            <Controller
              control={control}
              key={JSON.stringify(reserveDetailGroup ?? {}) + service?.toString() + `${nameDate}-${group.id}-IA` + JSON.stringify(reserveDetailJson)}
              name={`${nameDate}-${service}-${group.id}-IA`}
              render={({ field }) => <input
                type="checkbox"
                style={{ margin: "0 5px" }}
                title="فعال/غیرفعال"
                checked={field.value ?? false}
                {...field}
              />}
            />
            <span className="fw-bold"> {group.title}</span>
          </Col>
          <Col xs="10" sm="5" className="mt-2 mt-md-0 pr-2 d-flex align-items-center">
            <Controller
              name={`${nameDate}-${service}-${group.id}-Des`}
              key={JSON.stringify(reserveDetailGroup ?? {}) + service?.toString() + `${nameDate}-${service}-${group.id}-Des` + JSON.stringify(reserveDetailJson)}
              control={control}
              render={({ field }) => (
                <SelectComponent
                  className="w-100"
                  variant="outlined"
                  size="small"
                  noLabel
                  placeholder="توضیحات گروه"
                  onChange={field.onChange}
                  value={field.value}
                  options={reserveDescriptions.map(item => ({ ...item, label: item.label.length > 40 ? item.label.slice(0, 40) + "…" : item.label }))}
                />
              )}
            />
            <Button
              onClick={() => openModalAddDescription(nameDate, group.id)}
              variant="light h-100 mx-1"
            >
              <AddCircleRounded
                fontSize="large"
                className="big-icon"
              />
            </Button>

          </Col>
          {/* <Col xs="2" sm="auto" className="my-auto px-0"></Col> */}
        </Row>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {reserveItems.map(function (item, index) {
          let reserveDetailItem =
            !_.isNil(reserveDetailGroup) && _.isArray(reserveDetailGroup.i)
              ? _.find(reserveDetailGroup.i, { iId: item.id })
              : "";

          const dayCapacity = watch(
            `${nameDate}-${service}-${group.id}-${item.id}-C`,
            reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay,
          ); //بررسی لحظه ای ظرفیت روزانه
          const fullCapacity = watch(
            `${nameDate}-${service}-${group.id}-${item.id}-IFC`,
            reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity,
          ); //بررسی لحظه ای ظرفیت تکمیل

          if (!_.isUndefined(item) && !_.isEmpty(item))
            return (
              <Row
                key={index}
                className="align-items-center position-relative"
                style={{ margin: "10px 0 15px 0" }}
              >
                <Col xs="12" sm className="px-0 d-flex align-items-center mb-3 mb-sm-0">
                  <Controller
                    key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-ID` + JSON.stringify(reserveDetailJson)}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-ID`}
                    control={control}
                    render={({ field }) =>
                      <input
                        type="checkbox"
                        style={{ margin: "0 5px" }}
                        title="نمایش/عدم نمایش"
                        checked={field.value ?? false}
                        {...field}
                      />
                    }
                  />
                  <Controller
                    key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-IA` + JSON.stringify(reserveDetailJson)}
                    control={control}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-IA`}
                    render={({ field }) => <input
                      type="checkbox"
                      style={{ margin: "0 5px" }}
                      title="فعال/غیرفعال"
                      checked={field.value ?? false}
                      {...field}
                    />}
                  />
                  <div className="d-flex align-items-center gap-3">
                    <span>{item.title}</span>
                    {!!item.packageItemIds.length &&
                      <Tippy
                        content={
                          <div className="d-flex flex-column gap-3">
                            <span style={{ fontSize: 10 }}>
                              این پکیج شامل آیتم های زیر است:
                            </span>
                            <ul dir="rtl" className="m-0 px-7 text-end">
                              {item.packageItemIds.map(item => {
                                const foundedItem = reserveItems.find(itemm => itemm.id == item);
                                return <li>{foundedItem?.title}</li>
                              })}
                            </ul>
                          </div>
                        }
                        placement="top"
                        trigger="click"
                        interactive
                      >
                        <span style={{ cursor: "pointer" }}>
                          <i className="fas fa-layer-group text-black opacity-50 mt-1" />
                        </span>
                      </Tippy>}
                  </div>
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <Controller
                    key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-MinC` + JSON.stringify(reserveDetailJson)}
                    control={control}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-MinC`}
                    render={({ field }) => <HTMLInput
                      hiddenClear={true}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        // فقط اعداد مثبت و صفر مجاز باشه
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        field.onChange(e)
                      }}
                      margin="normal"
                      variant="outlined"
                      size="small"
                      className="form-control text-center englishInput"
                      title="حداقل تعداد"
                      style={{
                        margin: "0 auto",
                        width: "60px",
                        height: "2.8rem",
                        padding: "0",
                      }}
                      type="number"
                      inputMode="numeric"
                    />}
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 mx-3 position-relative">
                  <Controller
                    control={control}
                    key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-C` + JSON.stringify(reserveDetailJson)}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-C`}
                    render={({ field }) => <HTMLInput
                      hiddenClear={true}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        // فقط اعداد مثبت و صفر مجاز باشه
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        field.onChange(e)
                      }}
                      margin="normal"
                      variant="outlined"
                      size="small"
                      className="form-control text-center englishInput"
                      title="ظرفیت روزانه"
                      style={{
                        margin: "0 auto",
                        width: "60px",
                        height: "2.8rem",
                        padding: "0",
                      }}
                      type="number"
                      inputMode="numeric"
                    />}
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 mx-3 position-relative">
                  {console.log(reserveDetailItem)}
                  <Controller
                    control={control}
                    key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-iMGC` + JSON.stringify(reserveDetailJson)}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-MGC`}
                    render={({ field }) =>
                      <HTMLInput
                        hiddenClear={true}
                        value={field.value ?? ""}
                        onInput={(e) => {
                          // فقط اعداد مثبت و صفر مجاز باشه
                          e.target.value = e.target.value.replace(/[^0-9]/g, "");
                          field.onChange(e)
                        }}
                        margin="normal"
                        variant="outlined"
                        size="small"
                        className={`form-control text-center englishInput ${item?.packageItemIds?.length > 0 && "opacity-50"}`}
                        title="حداکثر تعداد گروه"
                        style={{
                          margin: "0 auto",
                          width: "60px",
                          height: "2.8rem",
                          padding: "0",
                        }}
                        type="number"
                        inputMode="numeric"
                        disabled={item?.packageItemIds?.length > 0}
                      />}
                  />
                </Col>
                {/* <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <Controller
                    control={control}
                    name={`${nameDate}-${group.id}-${item.id}-IDL`}
                    render={({ field }) => <input
                      type="checkbox"
                      style={{ margin: "0 5px" }}
                      title="محدودیت روزانه اعمال شود؟"
                      checked={field.value}
                      {...field}
                    />}
                  />
                </Col> */}
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <div style={{ transform: "scale(0.7)", marginTop: -3 }}>
                    <Controller
                      key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-iIFC` + JSON.stringify(reserveDetailJson)}
                      name={`${nameDate}-${service}-${group.id}-${item.id}-IFC`}
                      control={control}
                      render={({ field: { onChange, value } }) => {
                        return (
                          <SwitchBox
                            key={JSON.stringify(reserveDetailGroup ?? {}) + JSON.stringify(reserveDetailItem ?? {}) + service + `${nameDate}-${group.id}-${item.id}-iIFC` + JSON.stringify(reserveDetailJson)}
                            items={switchItems1}
                            value={value ?? switchItems1[0].value}
                            onChange={onChange}
                            label="تکمیل ظرفیت"
                            noShadow
                            mobileStyle
                            noTransForm
                          />
                        );
                      }}
                    />
                  </div>
                </Col>
                <Col xs="auto" className="px-0 mb-2 mt-4 mb-sm-0 min-width-price">
                  <label style={{ margin: "0 5px" }} className="text-decoration-line-through ">
                    <SplitNumber number={item.originalPrice} />
                  </label>
                  <label style={{ margin: "0 5px" }} className="">
                    <SplitNumber number={item.price} />
                  </label>
                </Col>
                <Col style={{ minWidth: 50 }} xs="auto" sm="auto" className="px-0 mb-2 mt-4 mb-sm-0 text-center">
                  <label dir="ltr" style={{ margin: "0 5px" }} className="text-primary">
                    {formatTime(item.reservationExpirationTime)}
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 text-center mb-2 mt-4 mb-sm-0">
                  <span style={{ width: "32px", display: "inline-block" }}>
                    {!_.isEmpty(item.reservationByPhone) && (
                      <Tooltip title={item.reservationByPhone} arrow placement="top">
                        <i className="fa fa-phone text-primary"></i>
                      </Tooltip>
                    )}

                    {((_.isEmpty(item.reservationByPhone) &&
                      (_.isEmpty(_.trim(dayCapacity)) || _.parseInt(dayCapacity) == 0) &&
                      dayCapacity !== undefined) ||
                      fullCapacity) && (
                        <Tooltip title="آیتم قابل رزرو نمی باشد" arrow placement="top">
                          <i className="fa fa-eye-slash text-danger fs-normal flipX"></i>
                        </Tooltip>
                      )}
                  </span>
                </Col>
              </Row>
            );
        })}
      </div >
    </div >
  )
}

export default memo(ReserveItemGroup)